import { writable } from "svelte/store";
import type { Suggestion } from "../../common/types.ts";

export const suggestions = writable<Array<Suggestion>>([]);
